import { render, staticRenderFns } from "./FullBgCard.vue?vue&type=template&id=6173abee"
import script from "./FullBgCard.vue?vue&type=script&lang=js"
export * from "./FullBgCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports